$(document).ready(function(){
    $("#testimonial-slider").owlCarousel({
        navigation: true,
        slideSpeed : 500,
        paginationSpeed : 500,
        items: 1,
        autoPlay: 3000,
    });
    $('.counter').counterUp({
        delay: 10,
        time: 1000
    });
    $('a[href^="#"]').click(function (e) {
        var anchor = $(e.target).closest('a').attr('href')
        if (anchor.length >= 2) {
            e.preventDefault();
            var $anchor = $(anchor);
            var scrollTop = $anchor.offset().top
            $('html, body').stop().animate({
                scrollTop: scrollTop
            }, 1000);
        }
    });
    $('.form-contact').on('submit', function (e) {
        e.preventDefault();
        var $form = $(e.target).closest('form');
        $.ajax({
            url: $form.attr('action'),
            method: $form.attr('method'),
            data: $form.serializeArray(),
            success: function (data, textStatus, jqXHR) {
                bootbox.alert("Invio completato con successo, ti contatteremo al più presto.");
                $form.find('input[type=email]').val('');
            },
            error: function (data, textStatus, jqXHR) {
                bootbox.alert("Si è verificato un errore, si prega di riprovare più tardi.");
            }
        })
    });
});